import styled from "styled-components";


export const Card = styled.div`
    display: inline-block;
    background-color: white;
    border-radius: 5px;
    border: 1px solid #999;
    margin: 10px 20px;
    padding: 20px;
    width: auto;
    font-size: 18px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        border-color: #666;
    }
`;